import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE } from './api/client';
import './AdminJobApplication.css';

const AdminJobApplication = ({ jobId }) => {
    const [applications, setApplications] = useState([]);
    const navigate = useNavigate(); // Initialize navigate for navigation

    useEffect(() => {
        const fetchApplications = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${API_BASE}/api/job/admin/jobs/${jobId}/applications`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (!response.ok) {
                    throw new Error('Failed to fetch applications');
                }
                const data = await response.json();
                setApplications(data);
            } catch (error) {
                console.error("Error fetching applications:", error);
            }
        };
        fetchApplications();
    }, [jobId]);

    // Navigate to the detailed view of an application
    const handleClick = (appId) => {
        navigate(`/application/${appId}`); // Use navigate to go to the detailed application page
    };

    return (
        <div className="AdminJobApplication">
            <h2>Applications</h2>
            {applications.map((app) => (
                <div key={app._id} className="application-card" onClick={() => handleClick(app._id)}>
                    {/* Display the first 3 fields */}
                    <ul>
                        {Object.entries(app.fields).slice(0, 3).map(([key, value]) => (
                            <li key={key}>
                                <strong>{key}:</strong> {value}
                            </li>
                        ))}
                    </ul>
                    {/* Display Submitted At */}
                    <p><strong>Submitted At:</strong> {new Date(app.submittedAt).toLocaleString()}</p>
                </div>
            ))}
        </div>
    );
};

export default AdminJobApplication;
